// CMS MBI: strip symbols, uppercase, max 11 alphanumeric characters.
function sanitizeMBI(value) {
  if (!value) return "";
  return String(value).replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 11);
}

// CMS MBI rules matching util/mbi.go:
// positions 1,4,7,10,11 digits (pos 1 is 1-9);
// positions 2,5,8,9 letters; positions 3,6 letter-or-digit;
// no letter may be S, L, O, I, B, or Z.
function isValidMBI(value) {
  return /^[1-9][ACD-HJ-KM-NP-RT-Y][A-Z0-9][0-9][ACD-HJ-KM-NP-RT-Y][A-Z0-9][0-9][ACD-HJ-KM-NP-RT-Y][ACD-HJ-KM-NP-RT-Y][0-9][0-9]$/.test(value);
}

export { sanitizeMBI, isValidMBI };
